import React, { useState, Fragment, useRef } from "react";
import { unmountComponentAtNode, createPortal } from "react-dom";
import { Form } from 'react-bootstrap'
import { withAITracking } from "@microsoft/applicationinsights-react-js";
import { reactPlugin } from "../../utils/AppInsights";
import VGPopUp from "../Controls/VGPopUp";
import { utils, VagaroAPIURL } from "utils/Utils";
import { AsyncAjaxPost } from 'components/Common/AsyncAjaxService'

const ChangeNickName = (props) => {

    //Only 2 State Allow 
    const [selctedValue, setSelectedValue] = useState(props.mappingType);
    const [url, setURL] = useState(props.mappingType == 1 ? props.urlAddress : (props.mappingType == 2 ? props.urlName : ((props.mappingType == 3 ? props.nickName : ""))));

    const ChangeBusinessType = (event) => {
        if (event.target.value == 1) {
            setURL(props.urlAddress);
        }
        else if (event.target.value == 2) {
            setURL(props.urlName);
        }
        else if (event.target.value == 3) {
            setURL(props.nickName);
        }
        setSelectedValue(event.target.value);
    }


    const ApplyChanges = () => {
        try {
            PopupClose();
            props.setApplyGrid(selctedValue);
        } catch (error) {
            
        }
    }

    const EditStyleBody = () => {
        return (
            <div>
                <div className="form-content" style={{ marginBottom: "10px" }}>
                    Edit your multi-location URL.
                </div >
                <div className="form-content">
                    <div className="form-row" style={{ marginBottom: "10px" }}>
                        <label className="form-label">URL Type:</label>
                        <div className="vg-wb-select">
                            <select className="form-control" onChange={(e) => ChangeBusinessType(e)}>
                                <option value={1} selected={selctedValue == 1 ? "selected" : ""}>Address</option>
                                <option value={2} selected={selctedValue == 2 ? "selected" : ""}>Business Name</option>
                            </select>
                        </div>
                        <div className="allurl">This will apply to all URLs.</div>
                    </div>

                    <div className="form-row">
                        <label className="form-label">Updated URL:</label>
                        <label className="form-label mysite-url">{utils.MySiteName().replace("https://", "") + '/' + props.vagaroURL + '/' + url}</label>
                        {props.domainName != "" &&
                            <label className="form-label mysite-url">{props.domainName.replace("https://", "") + '/' + url}</label>
                        }

                    </div>


                </div>
            </div>

        )
    }

    const EditStyleFooter = () => {
        return (
            <Fragment>
                <button className="w-button w-button-secondary" onClick={() => PopupClose()}>Cancel</button>
                <button className="w-button w-button-primary" onClick={() => ApplyChanges()}>Save</button>
            </Fragment>
        )
    }

    const PopupClose = () => {
        unmountComponentAtNode(document.getElementById("OpenDialog"));
    };
    return createPortal(
        <Fragment>
            <VGPopUp
                id={"ChangeNickName"}
                show={true}
                title={"Edit URL"}
                onHide={PopupClose}
                size="sm"
                body={EditStyleBody()}
                dialogClassName="vg-w480"
                footer={EditStyleFooter()}
                isShowFooter={true}
                backdrop={true}
                isRemoveTabModalIndex={true}
            />
        </Fragment>,
        document.getElementById("OpenDialog")
    )
}

export default withAITracking(reactPlugin, ChangeNickName);